var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnnoyed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f26b1d}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "annoyed",
    d: "M18.8 18.8a2.4 2.4 0 1 0 2.4 2.4 2.4 2.4 0 0 0-2.4-2.4zm14.4 9.6a12 12 0 0 0-10.488 6.168 2.386 2.386 0 1 0 4.152 2.352A7.2 7.2 0 0 1 33.2 33.2a2.4 2.4 0 0 0 0-4.8zm0-9.6a2.4 2.4 0 1 0 2.4 2.4 2.4 2.4 0 0 0-2.4-2.4zM26 2a24 24 0 1 0 24 24A24 24 0 0 0 26 2zm0 43.2A19.2 19.2 0 1 1 45.2 26 19.2 19.2 0 0 1 26 45.2z",
    className: "cls-1",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnoyed);
export default __webpack_public_path__ + "static/media/icon-annoyed.ddfdd577c8744b34ea7d435bfb83773e.svg";
export { ForwardRef as ReactComponent };